"use strict";

import axios from "@/plugins/axios";
import he from 'he';

export const course = {
  namespaced: true,
  state: {
    currentCourse: {},
    times_of_currentCourse: [],
    data: [],
    trainers: []
  },
  getters: {
    getCourses: state => state.data,
    getTrainers: state => state.trainers,
    getCourse: state => state.currentCourse,
    getTimes: state => state.times_of_currentCourse,
    getSortedTimes: state => {
      let montag = [], dienstag = [], mittwoch = [], donnerstag = [], freitag = [], samstag = [], sonntag = [];
      state.times_of_currentCourse.forEach(time => {
        switch (time.day) {
          case "Montag":
            montag.push(time);
            break;
          case "Dienstag":
            dienstag.push(time);
            break;
          case "Mittwoch":
            mittwoch.push(time);
            break;
          case "Donnerstag":
            donnerstag.push(time);
            break;
          case "Freitag":
            freitag.push(time);
            break;
          case "Samstag":
            samstag.push(time);
            break;
          case "Sonntag":
            sonntag.push(time);
            break;
          default:
            break;
        }
      })
      return [
        ...montag, ...dienstag, ...mittwoch, ...donnerstag, ...freitag, ...samstag, ...sonntag
      ]
    }
  },
  mutations: {
    UPDATE_DATA: (state, payload) => (state.data = payload),
    UPDATE_TRAINERS: (state, payload) => (state.trainers = payload),
    SET_CURRENT_COURSE: (state, payload) => (state.currentCourse = payload),
    SET_TIMES_OF_CURRENT_COURSE: (state, payload) => (state.times_of_currentCourse = payload),
  },
  actions: {
    async getCourse({ commit, state }, payload) {
      try {
        commit('SET_CURRENT_COURSE', state.data.filter(couse => couse._id === payload)[0]);
      } catch (error) {
        return error;
      }
    },
    async makePublic({ commit }, payload) {
      try {
        let res = (await axios.get(`/api/course/publish/${payload}`,)).data
        if (res.success) commit('SET_CURRENT_COURSE', res.data)
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        return error;
      }
    },
    async getTimes({ commit }, payload) {
      try {
        let res = (await axios.get(`/api/times/${payload}`)).data
        if (res.success) commit('SET_TIMES_OF_CURRENT_COURSE', res.data);
      } catch (error) {

        return error;
      }
    },
    async getCourseById({ commit }, payload) {
      try {
        let res = (await axios.get(`/api/course/${payload}`)).data
        if (res.success) {
          res.data.trial_training = he.decode(res.data.trial_training);
          res.data.description = he.decode(res.data.description);
          commit('SET_CURRENT_COURSE', res.data)
        }
      } catch (error) {
        return error
      }
    },
    async getCourses({ commit }) {
      try {
        let res = (await axios.get("/api/courses")).data;
        res.data.forEach((course, index) => {
          res.data[index].trial_training = he.decode(course.trial_training);
          res.data[index].description = he.decode(course.description);
        });

        commit("UPDATE_DATA", res.data);
      } catch (error) {

        return error
      }
    },
    async uploadImage({ state }, payload) {
      try {

        let res = (
          await axios.post("api/course/profileImage", payload, {
            headers: { "Content-Type": "multipart/f orm-data" },
          })
        ).data;

        if (res.success) {
          state.data.filter((course, index) => {
            if (course._id === res.data._id) state.data[index].photoURL = res.data.photoURL;
          })
          state.currentCourse.photoURL = res.data.photoURL;
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },

    async updateTime(_context, payload) {
      try {
        let res = (await axios.put('api/times', payload)).data
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          return true;
        }
      } catch (e) {
        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },

    async blockCourse({ state }, payload) {
      try {
        let res = (await axios.get(`/api/course/block/${payload}`)).data;
        if (res.success) state.data.filter((course, index) => {
          if (course._id === payload) {

            state.data[index].blocked = !state.data[index].blocked;
            state.data[index].blocked_by = res.data.blocked_by;
          }
        })
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        return error
      }
    },

    async updateCourse({ state }, payload) {
      try {
        let res = (await axios.post("api/course", payload)).data;
        if (res.success) {
          res.data.description = he.decode(res.data.description);
          res.data.trial_training = he.decode(res.data.trial_training);
          state.data.map(course =>
            course.title === res.data.title ? res.data : course
          )
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },
    async createNewTrainer({ state }, payload) {
      try {
        let res = (await axios.post('api/trainer', payload)).data

        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) { state.data = state.data.unshift(res.data); return true; }
      } catch (e) {

        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },
    async createNewCourse({ dispatch }, payload) {
      try {
        let res = (await axios.post('api/courses', payload)).data

        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          dispatch("getCourses");
          dispatch("user/getUsers", {}, { root: true });
          return true;
        }
      } catch (e) {
        return e;
      }
    },
    async getTimesforCourse({ state }, payload) {
      try {


        let res = (await axios.get(`/api/times/${payload._id}`)).data;
        if (res.success) {
          state.data.forEach((item, i) => {
            /* eslint-disable-next-line no-unused-vars */
            Object.entries(item).map(([key, val]) => {
              val = JSON.parse(JSON.stringify(val))

              if (key === '_id' && val === payload._id) {
                state.data[i].times = res.data;
              }
            })
          });
        }
      } catch (error) {

        return error
      }
    },

    async deleteTime({ state }, payload) {
      try {
        let res = (await axios.delete(`api/time/${payload}`)).data
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          state.times_of_currentCourse.push(res.data);
          return true;
        }
      } catch (e) {
        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },

    async deleteCourse({ state, dispatch }, payload) {
      try {
        let res = (await axios.delete(`api/course/${payload.id}`)).data
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          dispatch("user/getUsers", {}, { root: true })
        }
        state.data = state.data.filter(course => course._id !== payload.id);
      } catch (e) {
        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },

    async addTime({ state }, payload) {
      try {
        let res = (await axios.post('api/times', payload)).data
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          state.times_of_currentCourse.push(res.data);
          return true;
        }
      } catch (e) {
        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },
    async getTrainers({ commit }) {
      try {
        let data = (await axios.get("/api/trainers")).data;

        commit("UPDATE_TRAINERS", data.data);
      } catch (error) {

        return error
      }
    }
  }
};
